import { ref, Ref } from "vue";
import { useRouter } from "vue-router";
import { UserAuth } from "@/business/auth/domain/login";
import { getUserSession } from "@/business/auth/application/getUserSession";
import { saveSession } from "@/business/shared/session/application/saveSession";
import { closeSessionMemory } from "@/business/shared/session/application/closeSessionMemory";
import { resetUserAuthSession } from "@/business/auth/application/resetUserAuthSession";

export function layoutUse() {
  const userAuth: Ref<UserAuth | null> = ref(getUserSession.execute());
  const router = useRouter();

  async function closeSessionOperation(): Promise<void> {
    await Promise.all([
      resetUserAuthSession.execute(),
      closeSessionMemory.execute(),
    ]);

    await router.push("/login");
  }

  async function saveSessionTransaction(): Promise<void> {
    await saveSession.execute();
  }

  return {
    userAuth,
    closeSessionOperation,
    saveSessionTransaction,
  };
}